<template>
  <v-container full-width class="factsheet-global px-6">
    <nonmapHeader />
    <v-row>
      <v-col class="pt-0">
        <!-- MAIN SECTION -->
        <stateFactsheet
          v-if="
            selectedItemValue !== 'Global' && selectedItemType === 'Geography'
          "
        />
        <globalFactsheet v-if="selectedItemValue === 'Global'" />
        <facilityFactsheet v-if="selectedItemType === 'Facility'" />
        <v-row
          v-if="tableDataLoaded && selectedItemType !== 'Facility'"
          class="energy-tables container pa-0 mt-0 break-before"
        >
          <v-col class="pl-6 pr-0">
            <factsheet-table status="operational" />
            <factsheet-table status="development" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <p
      v-if="
        tableDataLoaded &&
        selectedItemType === 'Facility' &&
        facilityTemplate.disclaimer1
      "
      class="caption font-weight-light"
    >
      {{ facilityTemplate.disclaimer1 }}
    </p>
    <p
      v-if="tableDataLoaded && selectedItemType !== 'Facility'"
      class="caption font-weight-light"
    >
      {{ tableDisclaimer }}
    </p>
    <template
      class="break-before"
      v-if="facilityTemplate.techTitle && facilityTemplate.techOverview"
    >
      <nonmapHeader />
      <factsheetTech />
    </template>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import nonmapHeader from '@/components/main-nonmap-header';
import listConfig from '@/config/listConfig';
import appConfig from '@/config/appConfig';
import factsheetTable from '@/components/factsheet-table';
import stateFactsheet from '@/components/main-nonmap-state';
import globalFactsheet from '@/components/main-nonmap-global';
import facilityFactsheet from '@/components/main-nonmap-facility';
import factsheetTech from '@/components/factsheet-tech';

const vueName = 'NonMapView';
export default {
  name: vueName,
  components: {
    nonmapHeader,
    factsheetTable,
    stateFactsheet,
    globalFactsheet,
    facilityFactsheet,
    factsheetTech
  },
  data() {
    return {
      energyTypes: listConfig.energyTypes,
      sortBy: listConfig.sortBy,
      hideDistrict: false,
      tableDisclaimer: appConfig.tableDisclaimer.label
    };
  },
  computed: {
    ...mapState({
      drawer: 'drawer',
      facilityTemplate: 'facilityTemplate',
      geographyTemplate: 'geographyTemplate'
    }),
    ...mapGetters({
      profile: 'profileConfig/profile',
      mapTemplate: 'profileConfig/mapTemplate',
      selectedItemValue: 'mapTemplate/selectedItemValue',
      selectedItemType: 'mapTemplate/selectedItemType',
      profileDataLoaded: 'profileConfig/profileDataLoaded',
      geographyProfileLoaded: 'geographyTemplate/profileLoaded',
      facilityProfileLoaded: 'facilityTemplate/profileLoaded',
      tableDataLoaded: 'tableData/tableDataLoaded'
    }),
    templateSelected: function () {
      if (this.selectedItemType == 'Facility') {
        return this.facilityTemplate;
      } else {
        console.log('geography');
        return this.geographyTemplate;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations({
      setLoading: 'mapTemplate/setLoading'
    })
  },
  watch: {
    profileDataLoaded: function (newValue, oldValue) {
      if (newValue) {
        //console.log('Loaded', selectedItemType);
        this.setLoading(false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.factsheet-global {
  color: $ne-textcolor;
}

.break-before {
  break-before: always;
  page-break-before: always;
}

p.body-2 {
  line-height: 1.125;
}

.print-width {
  width: 100%; //860px;
}

* {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari */
  color-adjust: exact !important; /*Firefox*/
}

a:link {
  text-decoration: none;
}

.table-image {
  max-width: 150px;
  max-height: 100px;
  margin: 5px;
}
.v-data-table {
  .v-data-table-header {
    background-color: $ne-lightgray;
  }
  td:first-child {
    padding-left: 0;
    padding-right: 0;
  }
  // hide last column (STATUS) completely - Needed for filtering to work.
  th:last-child,
  td:last-child {
    width: 0;
    margin: 0;
    padding: 0;
  }
}
</style>
